function isValidOfferType(type) {
    return type === '1P' || type === '3P';
}
class RecommendationAdapter {
    // Input object
    recommendation;
    // Wrapper
    prices;
    // Normalized fields
    link;
    productShopIdentifier;
    articleId;
    productName;
    variantName;
    image;
    rating;
    reviewCount;
    beforePrice;
    rawCurrentPriceLabel;
    currentPriceLabelSecondaryCurrency;
    currentPriceSecondaryCurrency;
    currentPriceLabel;
    currentPrice;
    beforePriceLabel;
    beforePriceLabelFull;
    unitPriceLabel;
    discountType;
    discountValue;
    zooplusChoice;
    sponsored;
    tooltip;
    referencePrice;
    unit;
    autoshipment;
    autoshipmentPrice;
    locale;
    priceType;
    constructor(recommendation) {
        this.recommendation = recommendation;
        this.link = this.getLink();
        this.productShopIdentifier = this.getProductShopIdentifier();
        this.articleId = this.getArticleId();
        this.productName = this.getProductName();
        this.variantName = this.getVariantName();
        this.image = this.getPictureUrl();
        this.rating = this.getRating();
        this.reviewCount = this.getReviewCount();
        // Wrapper
        this.prices = this.getPriceFields();
        this.autoshipmentPrice = this.prices.autoshipmentPriceValue;
        this.beforePrice = this.prices.beforePriceValue;
        this.beforePriceLabel = this.prices.beforePriceLabel;
        this.beforePriceLabelFull = this.prices.beforePriceLabelFull;
        this.currentPrice = this.prices.currentPriceValue;
        this.currentPriceLabel = this.prices.currentPriceLabel;
        this.currentPriceLabelSecondaryCurrency = this.prices.currentPriceLabelSecondaryCurrency;
        this.currentPriceSecondaryCurrency = this.prices.currentPriceSecondaryCurrency;
        this.unitPriceLabel = this.prices.unitPriceLabel;
        this.rawCurrentPriceLabel = this.prices.rawCurrentPriceLabel;
        this.tooltip = this.prices.tooltip;
        this.unit = this.getUnit();
        this.discountType = this.prices.discountType;
        this.discountValue = this.prices.discountValue;
        this.priceType = this.prices.priceType;
        this.zooplusChoice = this.getZooplusChoice();
        this.sponsored = this.getSponsored();
        this.referencePrice = this.getReferencePrice(this.priceType);
        this.autoshipment = this.hasAutoshipmentPrice();
        this.locale = this.getLocale();
    }
    hasAutoshipmentPrice() {
        return this.getPriceFields().autoshipmentPriceValue !== undefined;
    }
    getArticleId() {
        return this.recommendation.article.id;
    }
    getLink() {
        return this.recommendation.product.link;
    }
    getLocale() {
        return this.recommendation.locale;
    }
    getPictureUrl() {
        return this.recommendation.product.pictureUrl;
    }
    getProductName() {
        return this.recommendation.product.name;
    }
    getProductShopIdentifier() {
        return this.recommendation.product.shopIdentifier;
    }
    getRating() {
        return this.recommendation.product.feedbackAggregate?.rating;
    }
    _calculateDiscount() {
        if (!this.beforePrice || !this.currentPrice || this.beforePrice === 0) {
            return undefined;
        }
        return ((this.currentPrice - this.beforePrice) * 100) / this.beforePrice;
    }
    getReferencePrice(priceType) {
        const discount = this._calculateDiscount();
        const discountStr = priceType === 'OFFER' && discount ? `${Math.ceil(discount)}%` : undefined;
        return {
            label: this.prices.beforePriceLabelPrefix,
            amount: this.beforePriceLabel,
            difference: discountStr,
        };
    }
    getReviewCount() {
        return this.recommendation.product.feedbackAggregate?.reviewCount;
    }
    getSponsored() {
        return this.recommendation.product.badges?.sponsored ?? undefined;
    }
    getPriceFields() {
        const offer = this.recommendation.articleOffers.find((offer) => isValidOfferType(offer.type));
        const autoshipmentOffer = this.recommendation.articleOffers.find((offer) => offer.type === '1P_AUS');
        const abdOffer = this.recommendation.articleOffers.find((offer) => offer.type === '1P_ABD');
        return {
            discountType: abdOffer !== undefined ? 'abd' : undefined,
            discountValue: abdOffer?.discount?.value != undefined ? abdOffer.discount.value / 100 : undefined, // It's needed to divide it by 100 because SPC API response provides the discount on a scale of 100
            tooltip: offer?.tooltip,
            autoshipmentPriceValue: autoshipmentOffer?.price.label,
            unitPriceValue: offer?.unitPrice?.value,
            unitPriceLabel: offer?.unitPrice?.label,
            currentPriceValue: offer?.price.value,
            currentPriceLabel: offer?.price.label,
            currentPriceSecondaryCurrency: offer?.secondaryCurrency?.price.value,
            currentPriceLabelSecondaryCurrency: offer?.secondaryCurrency?.price.label,
            rawCurrentPriceLabel: offer?.price.labelPattern,
            beforePriceValue: offer?.referencePrice?.value,
            beforePriceLabel: offer?.referencePrice?.label,
            beforePriceLabelFull: offer?.referencePrice?.labelFull,
            beforePriceLabelPrefix: offer?.referencePrice?.labelPrefix,
            currency: offer?.price.currency,
            offerType: offer?.type,
            priceType: offer?.priceType,
        };
    }
    getUnit() {
        return this.recommendation.article.unit ?? undefined;
    }
    getVariantId() {
        return this.recommendation.article.variantId;
    }
    getVariantName() {
        return this.recommendation.article.name;
    }
    getZooplusChoice() {
        return this.recommendation.product.badges?.zooplusChoice ?? undefined;
    }
}

export { RecommendationAdapter };
//# sourceMappingURL=utils.js.map
